import PlayNextIcon from 'widget/components/PlayNextButton/primitives/PlayNextIcon';
import StyledPlayNextButton from 'widget/components/PlayNextButton/primitives/StyledPlayNextButton';

type Props = {
  onClick: () => void;
  sizeToHide: string;
};

export default function PlayNextButton({ onClick, sizeToHide }: Props) {
  return (
    <StyledPlayNextButton
      aria-label="Play-Next"
      onClick={onClick}
      sizeToHide={sizeToHide}
      type="button"
    >
      <PlayNextIcon />
    </StyledPlayNextButton>
  );
}
